/**
 * <TutorWeekEditorSkeleton> — la forme de l'éditeur de la semaine pendant que la semaine arrive.
 *
 * Les vrais intitulés (les deux parties numérotées), le champ de date, et des jours d'heures en
 * pilules de la hauteur d'un poussoir `sm`. « Ma dispo » le pose dans son squelette de page, l'étape
 * des créneaux de « Compléter mon profil » à la place de l'éditeur : jamais une semaine vide pendant
 * qu'arrive la vraie (Wajih, 03/11).
 */
import React from "react"
import { View } from "react-native"
import { StyleSheet } from "react-native-unistyles"

import { pushButtonBoxHeight } from "../../atoms/Buttons/Button/Button"
import { Stack } from "../../atoms/containers/Stack"
import { Skeleton } from "../../atoms/Skeleton"
import { TutorStepHeading } from "../../molecules/TutorStepHeading"
import { TUTOR_WEEK_EDITOR_TEXTS } from "./TutorWeekEditor"

const HOUR_WIDTHS = [78, 78, 78, 70]

function DaySkeleton() {
    return (
        <Stack gap="2">
            <Skeleton textSize="text-xs" width={64} />
            <View style={styles.hours}>
                {HOUR_WIDTHS.map((width, index) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <Skeleton key={index} shape="block" width={width} height={pushButtonBoxHeight("sm")} />
                ))}
            </View>
        </Stack>
    )
}

export function TutorWeekEditorSkeleton() {
    return (
        <Stack gap="6">
            <Stack gap="3">
                <TutorStepHeading number={1} title={TUTOR_WEEK_EDITOR_TEXTS.startTitle} />
                <Skeleton shape="block" height={72} radius="lg" />
            </Stack>
            <Stack gap="4">
                <TutorStepHeading number={2} title={TUTOR_WEEK_EDITOR_TEXTS.weekTitle} />
                <DaySkeleton />
                <DaySkeleton />
                <DaySkeleton />
            </Stack>
        </Stack>
    )
}

const styles = StyleSheet.create((theme) => ({
    hours: { flexDirection: "row", flexWrap: "wrap", gap: theme.spacing["2"] },
}))
